<nz-layout class="shell">
  @if (isSmallScreen() && !collapsed()) {
    <div
      class="shell-mask"
      aria-hidden="true"
      (click)="collapsed.set(true)"></div>
  }
  <nz-sider
    class="shell-sider"
    [class.shell-sider-overlay]="isSmallScreen()"
    nzBreakpoint="lg"
    nzCollapsible
    nzTheme="light"
    [nzCollapsed]="collapsed()"
    [nzCollapsedWidth]="isSmallScreen() ? 0 : 72"
    [nzTrigger]="null"
    [nzWidth]="232"
    (nzCollapsedChange)="collapsed.set($event)">
    <a
      class="shell-brand"
      routerLink="/">
      @if (collapsed()) {
        <img
          class="shell-brand-mark"
          alt="SmartHead"
          src="assets/images/logo-sh-small-turquoise.svg" />
      } @else {
        <img
          class="shell-brand-logo"
          alt="SmartHead"
          src="assets/images/logo-smarthead-turquoise.svg" />
        <span class="shell-brand-label">Admin</span>
      }
    </a>

    <ul
      class="shell-navigation"
      nz-menu
      nzMode="inline"
      [nzInlineCollapsed]="collapsed()">
      @for (item of navigationItems(); track item.path) {
        <li
          nz-menu-item
          nzMatchRouter
          [nzTooltipTitle]="collapsed() && !isSmallScreen() ? item.label : null"
          nz-tooltip
          nzTooltipPlacement="right">
          <a [routerLink]="item.path">
            <ui-icon [key]="item.icon"></ui-icon>
            <span class="shell-navigation-label">{{ item.label }}</span>
          </a>
        </li>
      }
    </ul>

    <button
      class="shell-collapse"
      [hidden]="isSmallScreen()"
      type="button"
      [attr.aria-label]="collapsed() ? 'Expand navigation' : 'Collapse navigation'"
      (click)="collapsed.set(!collapsed())">
      <ui-icon [key]="collapsed() ? 'chevron-right' : 'chevron-left'"></ui-icon>
    </button>
  </nz-sider>

  <nz-layout class="shell-main">
    <nz-header
      class="shell-header"
      [class.shell-header-production]="stage === 'production'">
      @if (isSmallScreen()) {
        <button
          class="shell-menu-button"
          type="button"
          aria-label="Open navigation"
          (click)="collapsed.set(false)">
          <ui-icon key="menu"></ui-icon>
        </button>
      }
      <span
        class="shell-stage"
        [class]="'shell-stage-' + stage">
        {{ stageLabel }}
      </span>

      <sh-profile-search
        class="shell-search"
        (profileSelected)="onProfileSelected($event)"></sh-profile-search>

      @if (user(); as user) {
        <button
          class="shell-user"
          type="button"
          nz-dropdown
          nzPlacement="bottomRight"
          nzTrigger="click"
          [nzDropdownMenu]="userMenu">
          <span class="shell-user-avatar">{{ user.email.charAt(0) }}</span>
          <span class="shell-user-email">{{ user.email }}</span>
          <ui-icon key="chevron-down"></ui-icon>
        </button>
        <nz-dropdown-menu #userMenu="nzDropdownMenu">
          <ul nz-menu>
            <li
              nz-menu-item
              (click)="onLogOutClick()">
              Log out
            </li>
          </ul>
        </nz-dropdown-menu>
      }
    </nz-header>

    <nz-content class="shell-content">
      <router-outlet></router-outlet>
    </nz-content>
  </nz-layout>
</nz-layout>
